import { WORKSPACE_SEGMENT_CONFIG_KEY } from "../constants/workspaceSegments";

/**
 * Monta `dadosEtapa` mínimo para POST /setup (sugestões IA) a partir do workspace atual.
 * @param {function(string, boolean, *)} byKey — retorno de useWorkspaceConfig().byKey
 */
export function buildSetupAiDadosEtapaFromWorkspace(byKey) {
  const parsed =
    typeof byKey === "function"
      ? byKey(WORKSPACE_SEGMENT_CONFIG_KEY, true, null)
      : null;
  const segmentKey =
    parsed && typeof parsed === "object" && parsed.segmentKey != null
      ? String(parsed.segmentKey).trim()
      : "";
  return {
    companyName: "",
    companyAbout: "",
    companyWebsite: "",
    segmento: segmentKey,
    segmentKey,
    publicoAlvo: "",
    focoPrincipal: "",
    maturidadeDigital: "",
    capacidadeEstrategica: "",
  };
}
